/* eslint-disable no-undef */
/* eslint-disable no-inner-declarations */
import { useEffect, useState } from 'react';
import user from '../../helpers/user';
import { __ } from '../../translations';
import withResponsiveStyles from '@intigral/shared/components/hocs/ResponiseStyles/withResponsiveStyles';
import { Box, ActivityList, Text } from '@intigral/shared';
import { container } from '@intigral/domain/lib/DataDomain';
import url from '../../helpers/url';
import { IChannelSeriesHistoryService } from '@intigral/domain/lib/application/services/ChannelSeriesHistoryService';
import { DI } from '@intigral/constant/config/DIContainer';

const TextWithStyle = withResponsiveStyles(Text);

const PAGE_NUMBER = 0;
const PAGE_SIZE = 100;

const emptyLoadingData = [
    {
        ts: 1692529156667,
        historyType: 'CHANNEL',
    },
];

export const ProfileHistory = (props) => {
    const profileName = atob(url.getQuery('profile'));
    const [historyResponse, setHistoryResponse] = useState([]);
    const [page, setPage] = useState(PAGE_NUMBER);
    const [fetchAll, setFetchAll] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    async function fetchKidsActivityHistory() {
        if (page === 0) {
            setIsLoading(true);
        }

        // const response = await di.channelSeriesHistory.getProfileWatchesHistory(
        //     user.getAPIKey(),
        //     profileName,
        //     user.getUsername(),
        //     page,
        //     PAGE_SIZE,
        //     user.getIdentityToken()
        // );

        const channelHistoryService = container.resolve<IChannelSeriesHistoryService>(
            DI.SERVICES.IChannelSeriesHistoryService
        );
        const response = await channelHistoryService.getProfileWatchesHistory(
            user.getAPIKey(),
            profileName,
            user.getUsername(),
            page,
            PAGE_SIZE,
            user.getIdentityToken()
        );

        if (response?.data?.historyResponse?.length <= 0) {
            setFetchAll(true);
        } else {
            setHistoryResponse(response?.data?.historyResponse ?? []);
        }

        if (page === 0) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchKidsActivityHistory();
    }, [page]);

    return (
        <div className="container">
            <Box theme="light" padding={{ default: '2x', md: '6x' }}>
                <TextWithStyle
                    as="h4"
                    variant="h4"
                    alignment="start"
                    margin={{ default: '2x', md: '3x' }}
                    paddingTop={{ default: '2x', md: '0' }}
                >
                    {__('kids_viewing_activity')}
                </TextWithStyle>
                <Text as="p" margin={{ default: '2x', md: '3x' }} alignment="start" color="gray">
                    {__('kids_days_history')}
                </Text>
                <ActivityList
                    heading={__('kids_history_title')}
                    seeMoreText={fetchAll ? '' : __('show_more')}
                    historyData={isLoading ? emptyLoadingData : historyResponse}
                    visibleQuantity={PAGE_SIZE}
                    onClick={(e) => {
                        e.stopPropagation();
                        setPage(page + 1);
                    }}
                    unsorted
                    isLoading={isLoading}
                />

                {historyResponse.length === 0 && (
                    <Text as="p" margin={{ default: '2x', md: '3x' }} alignment="center" color="gray">
                        {__('no_data_availble')}
                    </Text>
                )}
            </Box>
        </div>
    );
};
